<template>
    <div class="moniter">
    
        <el-row>
        <el-col :span="4"><div class="grid-content bg-purple">&nbsp;</div></el-col>
        <el-col :span="16">
            <div class="grid-content bg-purple-light">
                <el-row type="flex" justify="space-around">
                <el-col :span="6"><div class="mon"><a class="moniter_1" href="https://open.ys7.com/ezopen/h5/live?autoplay=1&accessToken=at.28dv2fby7qvwmcpjc3ichv7naom5twgi-6ezfjk35uv-0u1iw2k-rua6i9umn&validCode=YUHEGI&deviceSerial=F01130539&channelNo=1">监控设备1</a></div></el-col>
                <el-col :span="6"><div class="mon"><a class="moniter_1" href="https://open.ys7.com/ezopen/h5/live?autoplay=1&accessToken=at.28dv2fby7qvwmcpjc3ichv7naom5twgi-6ezfjk35uv-0u1iw2k-rua6i9umn&validCode=YUHEGI&deviceSerial=F01130165&channelNo=1">监控设备2</a></div></el-col>
                <el-col :span="6"><div class="mon"><a class="moniter_1" href="https://open.ys7.com/ezopen/h5/live?autoplay=1&accessToken=at.28dv2fby7qvwmcpjc3ichv7naom5twgi-6ezfjk35uv-0u1iw2k-rua6i9umn&validCode=YUHEGI&deviceSerial=F01130172&channelNo=1">监控设备3</a></div></el-col>
                </el-row>
            </div>
        </el-col>
        <el-col :span="4"><div class="grid-content bg-purple"></div></el-col>
        </el-row>  
    </div>
</template>
<script>

export default ({
    name:'jiankong',
    setup() {
        
    },
})
</script>
<style scoped>
.moniter{
        width: 100%;
        height: 30px;
        
        text-align: left;
        line-height: 30px;
    }
.mon{
    text-align: center;
    line-height: 30px;
}
</style>
